import { render, staticRenderFns } from "./ApproveEnvelopeDoneModal.vue?vue&type=template&id=47b8a818&lang=pug"
import script from "./ApproveEnvelopeDoneModal.vue?vue&type=script&lang=js"
export * from "./ApproveEnvelopeDoneModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports